enum PaymentAmountOptions {
  None = 'none',
  Remaining = 'remaining',
  Custom = 'custom',
}

export default PaymentAmountOptions
